import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'List of trusted & blocked devices',
    title: 'Recent activities',
  },
  fr: {
    description: 'Liste des appareils autorisés et bloqués',
    title: 'Activités récentes',
  },
} as const);

export default locales;
